import React from "react";
import { logout, parseURL } from "account-portal-library/lib/helperFunctions";
import AppVars from '../AppVars';
import Logger from '../Logger.js';
import Loader from './Loader';
import navigateWithAnalytics from "../analytics/navigateWithAnalytics.js";

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logoutUriMissing: false,
            logoutRedirectUri: null,
            logoutDomains: [],
            defaultUrl: appVars.getDefaultHomePage(),
            style: "TO"
        };
    }

    async componentDidMount() {
        try {
            // Clear session storage
            sessionStorage.removeItem("AP_SSID");
            sessionStorage.removeItem("AP_authId");

            logger.log("test", "Calling logout to remove lingering cookies");
            await logout(appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());

            // Fetch logout domains dynamically from CDN
            //const CONFIG_PATH = `/config/Toyota-Logout-Domains.json`;
            const CONFIG_PATH =`${appVars.getBaseUrl()}/config/Toyota-Logout-Domains.json`;
            console.log("Fetching config from:", CONFIG_PATH);
            
            let logoutDomains = [];
            try {
                const res = await fetch(CONFIG_PATH, { cache: "no-store" });
                if (!res.ok) { throw new Error(`Failed to fetch logout domains, status: ${res.status}`);
            }
                logoutDomains = await res.json();
                logger.log("test", "Logout domains loaded:", logoutDomains);
            } catch (err) {
                logger.log("test", "Error fetching logout domains, fallback to empty list", err);
                logoutDomains = { domains: [] };
            }

            this.setState({ logoutDomains });

            // Parse redirect URI from query params
            const logoutRedirectUri = this.parseLogoutRedirectUri(window.location.search);
            logger.log("test", "Logout redirect URI:", logoutRedirectUri);

            if (!logoutRedirectUri) {
                logger.log('test', 'post_logout_redirect_uri is not present in the URL params');
                this.setState({ logoutUriMissing: true });
                return;
            }

            const isUnsafe = this.isUnsafeRedirectUri(logoutRedirectUri);
            const isLogoutValid = this.isValidLogoutURL(logoutRedirectUri, logoutDomains);

            if (isUnsafe || !isLogoutValid) {
                logger.log('test', 'Unsafe or invalid logout redirect URI detected');
                this.setState({ logoutUriMissing: true });
                return;
            }

            // Save valid redirect URI in state
            this.setState({ logoutRedirectUri });

            // Determine style (LD/DG)
            const hash = window.location.hash;
            if (hash.includes("dg") || hash.includes("DG")) {
                this.setState({ style: "DG" });
            }

        } catch (error) {
            logger.log("test", "Error during logout:", error);
            this.setState({ logoutUriMissing: true });
        }
    }

    parseLogoutRedirectUri = (url) => {
        try {
            const params = parseURL(url);
            if (params.post_logout_redirect_uri) {
                const decoded = decodeURIComponent(params.post_logout_redirect_uri);
                logger.log('test', 'post_logout_redirect_uri decoded:', decoded);
                return decoded;
            }
            return null;
        } catch (e) {
            logger.log("test", "Error parsing logout redirect URI:", e);
            return null;
        }
    }

    isUnsafeRedirectUri = (uri) => {
        const unsafePattern = /^(javascript:|data:text\/html|eval\(|onerror=|onload=|vbscript:|data:image\/svg\+xml|about:|window\.|document\.)/i;
        return unsafePattern.test(uri);
    }

    isValidLogoutURL = (logoutURL, logoutDomains) => {
        try {
            const decodedURL = decodeURIComponent(logoutURL);
            const parsedURL = new URL(decodedURL);
            const hostname = parsedURL.hostname.replace(/^www\./, "");
            return logoutDomains.domains.some(domain => hostname.endsWith(domain));
        } catch (e) {
            logger.log("test", "Error validating logout URL:", e);
            return false;
        }
    }

    render() {
        const { logoutRedirectUri, logoutUriMissing, defaultUrl } = this.state;

        // Show loader until redirect URI is determined
        if (logoutRedirectUri === null && !logoutUriMissing) return <Loader />;

        // Invalid or missing logout URI → redirect to default
        if (logoutUriMissing || !logoutRedirectUri) {
            navigateWithAnalytics(defaultUrl, "default-redirect", "auto");
            return null;
        }

        // Valid logout URI → redirect
        navigateWithAnalytics(logoutRedirectUri, "logout-redirect", "auto");
        return null;
    }
}

export default Logout;
